import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { PaginationInput, PaginationPageEvent, ReferenceParams, Res } from 'src/app/models';
import { LanguageService, ApiKaspiPricesService, ApiProductsService, NotificationService, ValidatorsService } from 'src/app/services';
import { ApiOzonProductListService } from 'src/app/services/integrations/ozon/api-ozon-product-list.service';
import { ApiOzonSettingsService } from 'src/app/services/integrations/ozon/api-ozon-settings.service';
import { KaspiPriceCreateValidator } from '../../kaspi/prices/kaspi-price-create/kaspi-price-create.validators';

@Component({
  selector: 'app-ozon-send-products',
  templateUrl: './ozon-send-products.component.html',
  styleUrls: ['./ozon-send-products.component.css']
})
export class OzonSendProductsComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  products: any[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent
  errorMessages: any;
  dimensions = [
    {id: 0, name: 'mm'},
    {id: 1, name: 'cm'},
    {id: 2, name: 'in'}
  ];
  vat = [
    {id: '0', name: '0 - не облагается НДС'},
    {id: '0.1', name: '0,1 - 10%'},
    {id: '0.2', name: '0,2 - 20%'}
  ];
  weightUnits = [
    {id: 0, name: 'g'},
    {id: 1, name: 'kg'},
    {id: 2, name: 'lb'}
  ];

  form: UntypedFormGroup = this.fb.group({
    // id: [null],
    products: this.fb.array([]),
  });


  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private apiOzonService: ApiOzonSettingsService,
    private notification: NotificationService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private validator: KaspiPriceCreateValidator,
    private validatorService: ValidatorsService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;

    this.getProducts();
    this.addProduct();

    this.form.get('products').valueChanges.subscribe(val=>{
      console.log("VAL: ", val);
      
    })

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   * @param searchValue 
   */
  getProducts(searchValue: string = ''): void {

    let params: ReferenceParams = {
      filter: {
        name: searchValue
      }
    }

    this.loading = true;
    this.products = [];

    this.subscriptions.add(
      this.apiOzonService.getReferences(params, 'products').subscribe((response: Res) => {
        console.log('[RESPONSE] getProducts: ', response);

        if (response != null) {

          let list: any[] = [];
          let products: any[] = this.form.get('products').value;

          for (let prod of response.result) {

            if (products.findIndex(val => val.product_id == prod.id) == -1) {

              list.push({ ...prod });
            }
          }

          this.products = [...list];
        }

        this.loading = false;
      },
        error => {
          this.loading = false;
          this.products = [];
        })
    );
  }


  /* OFFERS */

  /**
  * 
  * @param type string
  */
  addProduct(): void {

    let control = this.form.controls.products as UntypedFormArray;
    control.push(this.initOffer());
  }

  /**
   * 
   * @returns 
   */
  initOffer(): any {

    return this.fb.group({
      id:             [null],
      name:           [null],
      old_price:      [null],
      premium_price:  [null],
      price:          [null],
      dimension_unit: [null],
      vat:            [null],
      weight_unit:    [null]
    });
  }

  /**
   * 
   * @param i number
   */
  removeOffer(i: number): void {

    let control = this.form.controls.products as UntypedFormArray;
    control.removeAt(i);

    this.getProducts();
  }


  /* VALIDATION */

  /**
   * 
   * @param field 
   * @param type 
   */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }

  /**
   * 
   * @param field 
   */
  checkingFieldStatus(field: string): string {

    return this.validatorService.checkingFieldStatus(this.form.get(field));
  }


  /**
   * 
   */
  onCreate() {

    this.progressRef.start();

    let data = [ ...this.form.get('products').value ];

    this.subscriptions.add(
      this.apiOzonService.save(data).subscribe((response: Res) => {

        if (response != null) {

          this.router.navigate(['export', 'integrations', 'ozon']);
          this.notification.show('success', 'Данные успешно сохранены!');
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );

  }
}
